/* ==========================================================================
   Checkout Cancel Page
   Task F33: Return page when customer abandons Stripe Checkout
   ========================================================================== */

import { Link } from 'react-router-dom'
import { XCircle, Mail } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { MarketingLayout } from '@/components/layout/MarketingLayout'

export function CheckoutCancel() {
  return (
    <MarketingLayout>
      <main className="py-16">
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-charcoal/5 mb-6">
            <XCircle className="h-8 w-8 text-charcoal/40" aria-hidden="true" />
          </div>

          <h1 className="font-serif text-3xl text-charcoal mb-3">
            No worries
          </h1>
          <p className="text-lg text-charcoal/70 mb-8">
            Your subscription wasn't created. If you have questions or need
            help choosing a plan, we're here for you.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <a href="/#pricing">
              <Button variant="primary" size="lg" className="w-full sm:w-auto">
                View Pricing
              </Button>
            </a>
            <Link to="/contact-sales">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto">
                Contact Sales
              </Button>
            </Link>
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-charcoal/50">
            <Mail className="h-4 w-4" aria-hidden="true" />
            <span>
              Or email us at{' '}
              <a
                href="mailto:sales@tjmlabs.com"
                className="text-deep-purple hover:underline"
              >
                sales@tjmlabs.com
              </a>
            </span>
          </div>
        </div>
      </main>
    </MarketingLayout>
  )
}

export default CheckoutCancel
